import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { BaseCellRendererComponent } from '@examdojo/ag-grid';
import { connectState } from '@examdojo/angular/util';
import { TopicLevel2UIModel } from '@examdojo/category/v2';
import { IconComponent } from '@examdojo/core/icon';
import { PlatformService } from '@examdojo/platform';
import { ICellRendererParams } from 'ag-grid-community';
import { filter, map } from 'rxjs';

@Component({
  selector: 'dojo-topic-picture-cell-renderer',
  template: ` <div
    class="flex items-center gap-0 md:gap-2"
    [ngClass]="state.normalDisplay ? '' : state.isMobile ? 'mobile-display' : 'full-display'"
  >
    <div class="topics-circle-wrap flex flex-col items-center gap-1">
      <div
        class="assessment-topic-circle text-neutral-0"
        [ngClass]="['bg-dynamic-' + state.data.background_color + '-400']"
      >
        <dojo-icon
          [icon]="state.data.icon!"
          [faPrefix]="'fas'"
          [alt]="state.data.code"
          [size]="18"
          [ngClass]="['text-dynamic-' + state.data.background_color + '-50']"
        />
      </div>
      @if (state.isMobile) {
        <span class="text-primary whitespace-nowrap text-center text-sm">{{ state.data.code }}</span>
      }
    </div>

    <div class="flex flex-col">
      <div class="text-md text-primary ml-2 hidden whitespace-nowrap font-semibold md:inline md:font-normal">
        {{ state.data.code }}
      </div>
    </div>
  </div>`,
  imports: [NgClass, IconComponent, NgClass],
  host: { class: 'topic-picture-cell-renderer flex items-center justify-center' },
  styleUrl: './topic-picture-cell-renderer.component.scss',
})
export class TopicPictureCellRendererComponent extends BaseCellRendererComponent<string> {
  constructor(private readonly platformService: PlatformService) {
    super();
  }
  readonly state = connectState({
    data: this.data$.pipe(
      filter((data): data is TopicLevel2UIModel => Boolean(data)),
      map((data: TopicLevel2UIModel) => {
        return {
          code: data.code,
          background_color: data?.topicLevel1?.color_name,
          icon: data.icon,
          short_name: data.short_name,
        };
      }),
    ),
    isMobile: this.platformService.isSmall$,
    normalDisplay: this.params$.pipe(
      map((params: ICellRendererParams<unknown, string> & { normalDisplay?: boolean }) => params?.normalDisplay),
    ),
  });
}
